import { render, staticRenderFns } from "./EventIssue.vue?vue&type=template&id=fc4d032c&"
import script from "./EventIssue.vue?vue&type=script&lang=js&"
export * from "./EventIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports